module.exports = __webpack_public_path__ + "static/img/chamber.f164ac75.png";